export default __webpack_public_path__ + "static/media/ardennes.d5ca65dc.jpg";